import { Scope } from '../types/scope';

export const isAllowed = (
  scope: Scope | null | undefined,
  allowedScopes: Scope[],
): boolean =>
  scope === Scope.SUPERADMIN || (!!scope && allowedScopes.includes(scope));
